import React from 'react'

export const Col = ({ children, flex, width, gutter, wrap, style }) => {
  const innerStyle = {
    flex,
    width,
    padding: gutter ? gutter : 0,
    boxSizing: 'border-box',
    ...style
  }
  return (
    <div style={innerStyle} wrap={wrap}>
      {children}
    </div>
  )
}

const Grid = ({ children, justify, direction, align, gutter, wrap, style = {} }) => {
  const innerStyle = {
    display: 'flex',
    flexDirection: direction || 'row',
    justifyContent: justify || 'flex-start',
    alignItems: align || 'center',
    margin: gutter ? -gutter : 0,
    flexWrap: wrap && 'wrap',
    boxSizing: 'border-box',
    ...style
  }
  return <div style={innerStyle}>{children}</div>
}

export default Grid
